import { observer } from "mobx-react-lite";

import { Message } from "../Message";
import type { VibeChatStore } from "../stores";
import { type VisibleMessageRow, VisibleMessageRowType } from "../utils/buildVisibleMessageRows";

import { CompletedToolCallStack } from "./CompletedToolCallStack";
import ToolActivityThinkingBlock from "./ToolActivityThinkingBlock";

interface MessageRowProps {
  row: VisibleMessageRow;
  isLoading: boolean;
  chatStore: VibeChatStore;
  onRetry?: (messageIndex?: number) => void;
}

export interface MessagesVirtuosoContext {
  isLoading: boolean;
  chatStore: VibeChatStore;
  onRetry?: (messageIndex?: number) => void;
}

const MessageRowContent = observer(({ row, isLoading, chatStore, onRetry }: MessageRowProps) => {
  switch (row.type) {
    case VisibleMessageRowType.ToolActivity:
      return <ToolActivityThinkingBlock toolCalls={row.toolCalls} />;
    case VisibleMessageRowType.ToolStack:
      return <CompletedToolCallStack toolCalls={row.toolCalls} />;
    case VisibleMessageRowType.Message:
      return (
        <Message
          message={row.message}
          isLoading={isLoading}
          isLastMessage={row.isLastMessage}
          chatStore={chatStore}
          index={row.index}
          onRetry={onRetry}
        />
      );
    default:
      return null;
  }
});

export const MessageRow = observer((props: MessageRowProps) => (
  <div className="flex flex-col pb-3">
    <MessageRowContent {...props} />
  </div>
));

export const renderMessageRow = (
  _: number,
  row: VisibleMessageRow,
  context: MessagesVirtuosoContext,
) => (
  <MessageRow
    row={row}
    isLoading={context.isLoading}
    chatStore={context.chatStore}
    onRetry={context.onRetry}
  />
);
